(function() {
    function initYmalCarousel(wrapperId) {
        var wrapper = document.getElementById(wrapperId);
        if (!wrapper) return;

        var track = wrapper.querySelector('.ymal-carousel__track');
        var items = track.querySelectorAll('.ymal-carousel__item');
        if (items.length <= 2) return;

        var carousel = wrapper.closest('.ymal-carousel');
        var prevBtn = carousel.querySelector('[data-carousel-prev]');
        var nextBtn = carousel.querySelector('[data-carousel-next]');
        var currentIndex = 0;
        var itemsPerPage = 2;

        function getItemWidth() {
            return items[0].offsetWidth + 12;
        }

        function updateButtons() {
            prevBtn.disabled = currentIndex === 0;
            nextBtn.disabled = currentIndex >= items.length - itemsPerPage;
        }

        function scrollTo(index) {
            currentIndex = Math.max(0, Math.min(index, items.length - itemsPerPage));
            track.style.transform = 'translateX(-' + (currentIndex * getItemWidth()) + 'px)';
            updateButtons();
        }

        prevBtn.addEventListener('click', function() { scrollTo(currentIndex - 1); });
        nextBtn.addEventListener('click', function() { scrollTo(currentIndex + 1); });

        updateButtons();
    }

    document.querySelectorAll('[data-carousel-next]').forEach(function(btn) {
        var wrapperId = btn.getAttribute('data-carousel-next');
        initYmalCarousel(wrapperId);
    });

    document.querySelectorAll('.ymal-carousel__track').forEach(function(track) {
        if (track.querySelector('.ymal-carousel__shade-picker')) {
            track.querySelectorAll('.ymal-carousel__shade-picker-wrapper').forEach(function(wrapper) {
                wrapper.classList.add('ymal-carousel__shade-picker-wrapper--has-picker');
            });
        }
    });

    document.querySelectorAll('.ymal-carousel__shade-picker').forEach(function(picker) {
        var trigger = picker.querySelector('.ymal-carousel__shade-trigger');
        var swatchesPanel = picker.querySelector('.ymal-carousel__swatches');
        var swatchDot = picker.querySelector('.ymal-carousel__shade-swatch');
        var shadeName = picker.querySelector('.ymal-carousel__shade-name');
        var carouselWrapper = picker.closest('.ymal-carousel__wrapper');

        var currentLabel = picker.querySelector('.colors__item.current');
        if (currentLabel) {
            var box = currentLabel.querySelector('.colors__item-box');
            if (box) swatchDot.style.backgroundColor = box.style.backgroundColor;
            shadeName.textContent = currentLabel.getAttribute('data-color') || 'Choose Shade';
        }

        function closePanel() {
            swatchesPanel.classList.remove('is-open');
            if (carouselWrapper && !carouselWrapper.querySelector('.ymal-carousel__swatches.is-open')) {
                carouselWrapper.style.overflow = '';
            }
        }

        trigger.addEventListener('click', function(e) {
            e.stopPropagation();
            var opening = !swatchesPanel.classList.contains('is-open');
            swatchesPanel.classList.toggle('is-open');
        });

        picker.querySelectorAll('[data-colors-item]').forEach(function(label) {
            label.addEventListener('click', function() {
                var box = this.querySelector('.colors__item-box');
                if (box) swatchDot.style.backgroundColor = box.style.backgroundColor;
                shadeName.textContent = this.getAttribute('data-color') || 'Choose Shade';
                closePanel();
            });
        });
    });

    document.addEventListener('click', function() {
        document.querySelectorAll('.ymal-carousel__swatches.is-open').forEach(function(el) {
            el.classList.remove('is-open');
        });
        document.querySelectorAll('.ymal-carousel__wrapper').forEach(function(w) {
            w.style.overflow = '';
        });
    });
})();